import { Trans, useTranslation } from 'next-i18next';
import React from 'react';
import {
  DestinationAttributes,
  DestinationAttributesMobile,
} from '@hotelplan/components.common.destination-attributes';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { useObjectId } from '@hotelplan/libs.context.object-id';
import AttributesWrapper from 'components/core/attributes/AttributesWrapper';
import {
  PdpGeoPageText,
  PdpGeoPageImage,
  PdpGeoPageSubTitle,
  PdpGeoPageTitle,
} from 'components/domain/pdp/PdpGeoCommon';
import PdpPageContainer from 'components/domain/pdp/PdpPageContainer';
import { useGetPdpResortQuery } from 'graphql/pdp/GetPdpResort.generated';
import PdpResortSkeleton from './PdpResortSkeleton.skeleton';

const PdpResort: React.FC = () => {
  const [t] = useTranslation();
  const { id } = useObjectId();
  const { mobile } = useDeviceType();
  const { loading, data } = useGetPdpResortQuery({ variables: { id } });

  if (loading) {
    return (
      <PdpPageContainer>
        <PdpResortSkeleton />
      </PdpPageContainer>
    );
  }

  const { destinationInfo } = data?.pdp.content;

  return (
    <PdpPageContainer>
      <PdpGeoPageTitle>
        <Trans
          i18nKey={`pdp:resort.title`}
          components={[<span key="name" />]}
          tOptions={{ name: destinationInfo.resortName }}
        />
      </PdpGeoPageTitle>
      <PdpGeoPageText
        dangerouslySetInnerHTML={{
          __html: destinationInfo.resortLeadText,
        }}
      />
      <PdpGeoPageImage {...destinationInfo.resortImage} />
      {destinationInfo.resortFacts && (
        <PdpGeoPageText>{destinationInfo.resortFacts}</PdpGeoPageText>
      )}
      <PdpGeoPageSubTitle>{t('pdp:resort.facts.title')}</PdpGeoPageSubTitle>
      <AttributesWrapper>
        {mobile ? (
          <DestinationAttributesMobile
            attributes={destinationInfo.attributes}
          />
        ) : (
          <DestinationAttributes attributes={destinationInfo.attributes} />
        )}
      </AttributesWrapper>
    </PdpPageContainer>
  );
};

export default PdpResort;
